module.exports = __webpack_public_path__ + "static/media/shequ-title-3.f033d821.png";